import { REPEAT_TYPES } from "./constants"

export const generateId = () => `${Date.now()}_${Math.random()}`

export const defaultTimeRow = () => ({ id: generateId(), time: null })

export const formatSlotLabel = (date, time) =>
  `${date.format("ddd MMM D, YYYY")} ${time.format("h:mm A")}`

export const getDayIndicesForType = (repeatType) => {
  if (repeatType === REPEAT_TYPES.EVERYDAY) return [0, 1, 2, 3, 4, 5, 6]
  if (repeatType === REPEAT_TYPES.WEEKDAYS) return [1, 2, 3, 4, 5]
  if (repeatType === REPEAT_TYPES.WEEKEND) return [0, 6]
  return []
}

export const buildSlots = ({ startDate, endDate, timeRows, isRepeat, repeatType, customDays }) => {
  const activeDays = repeatType === REPEAT_TYPES.CUSTOM ? customDays : getDayIndicesForType(repeatType)
  const slots = []
  let current = startDate.clone()

  while (current.isBefore(endDate, "day") || current.isSame(endDate, "day")) {
    const include = !isRepeat || activeDays.includes(current.day())
    if (include) {
      timeRows.forEach((row) => {
        // starts_at is stored as ISO string so the payload builder can send it without reparsing the label
        const startsAt = current.clone().hour(row.time.hour()).minute(row.time.minute()).second(0).toISOString()
        slots.push({ id: generateId(), label: formatSlotLabel(current, row.time), starts_at: startsAt })
      })
    }
    current = current.add(1, "day")
  }

  return slots
}
